<template>
  <BaseItem
      ref="RefItem"
      :item-uid="itemUid"
      parentComponent="LibraryTopicTable"
      :lock-page="lockPage"
      dto-detail-model="LibraryTopicDetailQueryDTO"
      dto-save-model="LibraryTopicSaveCommandDTO"
      dto-restore-model="LibraryTopicRestoreCommandDTO"
      dto-filter-restore-model="LibraryTopicDetailResponseDTO"
      :dto_validate_model="null"
      :store-name="store_name"
      :modal-dialog="modalDialog"
      :routeFullScreen="routeFullScreen"
      :height="height"
      :width="width"
  >
    <template v-slot:body="{editedItem, editedItemCommon, slotHeight}">
      <v-text-field
          v-model="editedItem.name"
          :label="$t('columns.name')"
          dense
          outlined
          class="mb-n6 mx-3"
          counter="50"
          :filled="lockPage(editedItem)"
          :disabled="lockPage(editedItem)"
      ></v-text-field>
    </template>
  </BaseItem>
</template>

<script>
import ConfirmDialog from "@/components/Base/ConfirmDialog";
// import commonFunction from "@/commonFunction/commonFunction"
import BaseItem from "@/components/Base/BaseItem";
import {v4 as uuidv4} from "uuid";
import fileFunction from "@/commonFunction/fileFunction";
import TipTapEditor from "@/components/TipTap/TipTapEditor";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";


export default {
  name: 'LibraryTopicItem',
  props: {
    itemUid: {default: null},
    store_name: {type: [String], default: 'LibraryTopicTable'},
    modalDialog: {type: [Boolean], default: false},
    routeFullScreen: {type: [Object], default: null},
    height: {default: null},
    width: {default: null},
  },

  components: {
    BaseDeleteIcon,
    ConfirmDialog,
    BaseItem,
    TipTapEditor,
  },

  computed: {},

  methods: {
    onClose(event) {
      console.log('unload', event);
      if (this.$refs.RefItem.countBackup > 0) {
        event.returnValue = 'Do you really want to leave? you have unsaved changes!'
        return event.returnValue
      }
      return true
    },
    lockPage(editedItem) {
      return !(!!editedItem && !!editedItem.page_properties && !editedItem.page_properties.lock_page)
    },
  },

  async mounted() {
    window.addEventListener('beforeunload', this.onClose)
  }
  ,

  beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave')
    if (this.$refs.RefItem.countBackup === 0)
      next()
    else {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer)
        next()
      else
        next(false)
    }
  },

  data() {
    return {
      file: null,
    }
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "columns": {
      "deleted": " ",
      "edit": " ",
      "name": "Name",
      "created_by": "Created by",
      "created_by_name": "Created by",
      "created_on": "Created on",
      "edited_by": "Edited by",
      "edited_by_name": "Edited by",
      "edited_on": "Edited on"
    },
    "Save": "Save",
    "Cancel": "Cancel",
    "new_item": "New customer"
  },
  "de": {
    "columns": {
      "deleted": " ",
      "edit": " ",
      "name": "Name",
      "created_by": "Erstellt von",
      "created_by_name": "Erstellt von",
      "created_on": "Erstellt am",
      "edited_by": "Bearbeitet von",
      "edited_by_name": "Bearbeitet von",
      "edited_on": "Bearbeitet am"
    },
    "Save": "Speichern",
    "Cancel": "Stornieren",
    "new_item": "Neuer Kunde"
  }
}
</i18n>
